import React from 'react';
import { useTranslation } from 'react-i18next';

const variants = {
  primary: 'badge-primary',
  secondary: 'badge-secondary',
  success: 'badge-success',
  danger: 'badge-danger',
  accent: 'badge-accent',
  neutral: 'badge-neutral'
};

export default function Badge({
  children,
  variant = 'neutral',
  className = '',
  ...props
}) {
  const variantClass = variants[variant] || variants.neutral;
  
  return (
    <span className={`${variantClass} ${className}`} {...props}>
      {children}
    </span>
  );
}

export function StatusBadge({ status }) {
  const statusConfig = {
    new: { variant: 'success', label: 'New' },
    'follow-up': { variant: 'accent', label: 'Follow-up' },
    buyer: { variant: 'primary', label: 'Buyer' },
    'not-interested': { variant: 'danger', label: 'Not Interested' },
    draft: { variant: 'neutral', label: 'Draft' },
    active: { variant: 'success', label: 'Active' },
    'on_hold': { variant: 'accent', label: 'On Hold' },
    completed: { variant: 'primary', label: 'Completed' },
    cancelled: { variant: 'danger', label: 'Cancelled' },
    todo: { variant: 'neutral', label: 'To Do' },
    'in_progress': { variant: 'accent', label: 'In Progress' },
    review: { variant: 'secondary', label: 'Review' },
    sent: { variant: 'primary', label: 'Sent' },
    viewed: { variant: 'secondary', label: 'Viewed' },
    paid: { variant: 'success', label: 'Paid' },
    partial: { variant: 'accent', label: 'Partial' },
    overdue: { variant: 'danger', label: 'Overdue' }
  };
  
  const config = statusConfig[status?.toLowerCase()] || { variant: 'neutral', label: status };
  
  return <Badge variant={config.variant}>{config.label}</Badge>;
}

export function PriorityBadge({ priority }) {
  const { t } = useTranslation();
  const priorityConfig = {
    low: { variant: 'neutral', label: t('projects.priorities.low') },
    medium: { variant: 'primary', label: t('projects.priorities.medium') },
    high: { variant: 'accent', label: t('projects.priorities.high') },
    urgent: { variant: 'danger', label: t('projects.priorities.urgent') }
  };
  
  const config = priorityConfig[priority?.toLowerCase()] || { variant: 'neutral', label: priority };
  
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
